// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Service.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { get } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/Request';
/**
 * 系统服务 服务类
 * 系统服务
 */
export class SystemService {
  static async CreateUniqueKeyAsync(): Promise<string | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mda/service/systemservice/createuniquekey')
        .then((response: any) => {
          let result: string | null = null;
          if (response) {
            result = response as string;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async CreateUniqueKeyListAsync(count: number): Promise<Array<string> | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mda/service/systemservice/createuniquekeylist', { count: count })
        .then((response: any) => {
          let result: Array<string> | null = null;
          if (response) {
            const items = new Array<string>();
            response.forEach((item: any) => {
              items.push(item);
            });
            result = items;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }
}
